import React, { Component } from "react";
import cn from "classnames";
import Layout from "../Layout";
import "./VerticalCenterLayout.less";

const CLASS_NAME = "fct-vertical-center-layout";

class VerticalCenterLayout extends Component {
  render() {
    const { children, className, ...props } = this.props;
    return (
      <Layout className={cn(CLASS_NAME, className)} {...props}>
        {this._renderChildren()}
      </Layout>
    );
  }

  _renderChildren() {
    const { lgap, rgap, tgap, bgap, hgap, vgap, children } = this.props;
    if (
      lgap == null &&
      rgap == null &&
      tgap == null &&
      bgap == null &&
      hgap == null &&
      vgap == null
    ) {
      return children;
    }
    return React.Children.map(children, (child, i) => {
      return React.cloneElement(child, {
        ...(lgap != null || hgap != null
          ? {
              _lgap:
                (i === 0 ? hgap || 0 : 0) +
                (lgap || 0) +
                (child.props._lgap || 0)
            }
          : {}),
        ...(rgap != null || hgap != null
          ? {
              _rgap: (hgap || 0) + (rgap || 0) + (child.props._rgap || 0)
            }
          : {}),
        ...(tgap != null
          ? {
              _tgap: (tgap || 0) + (child.props._tgap || 0)
            }
          : {}),
        ...(bgap != null
          ? {
              _bgap: (bgap || 0) + (child.props._bgap || 0)
            }
          : {}),
        ...(vgap != null
          ? {
              _vgap: (vgap || 0) + (child.props._vgap || 0)
            }
          : {})
      });
    });
  }
}

export default VerticalCenterLayout;



// WEBPACK FOOTER //
// ./layout/center/VerticalCenterLayout.js